export type PriorityInboxLane = "risk" | "reply_obligation" | "opportunity";

export type PriorityInboxKind =
  | "ai"
  | "chat_threads"
  | "course_comments"
  | "dms"
  | "moderation";

export const PRIORITY_INBOX_KINDS = [
  "dms",
  "moderation",
  "course_comments",
  "chat_threads",
  "ai",
] as const satisfies readonly PriorityInboxKind[];

// Matches ThreadsController::ALLOWED_STATUSES.
export type PriorityInboxStatus = "solved" | "unsolved";

export const PRIORITY_INBOX_DEFAULT_STATUS: PriorityInboxStatus = "unsolved";

export const PRIORITY_INBOX_STATUSES = [
  "unsolved",
  "solved",
] as const satisfies readonly PriorityInboxStatus[];

export const isPriorityInboxKind = (
  value: string | undefined,
): value is PriorityInboxKind =>
  !!value && PRIORITY_INBOX_KINDS.some(kind => kind === value);

export interface PriorityInboxThreadDisplayContext {
  avatar_url?: string | null;
  chat_room_uuid?: string;
  chat_thread_id?: number;
  content?: string | null;
  name?: string | null;
  reason?: string;
}

export interface PriorityInboxThread {
  candidates_count: number;
  display_context: PriorityInboxThreadDisplayContext;
  groupable_id: number;
  groupable_type: string;
  id: number;
  kind: PriorityInboxKind | null;
  lane: PriorityInboxLane | null;
  lane_rank: number;
  last_activity_at: string;
  read_at: string | null;
  severity: string | null;
  solved_at: string | null;
  source_type: string | null;
  waiting_since: string;
}
